import React, { FC } from 'react';
import { Box, Typography } from '@material-ui/core';
import PriceWithLabel from '../../../../customiseContainer/footer/PriceSection/CarPrices/PriceWithLabel/PriceWithLabel';
import IndicativeNumber from '../../../../../../common/components/indicativeNumber/IndicativeNumber';
import singleCurrencyCashStyles from './singleCurrencyCashStyles';
import IPrice from '../../../../../../gqlCommon/model/prices/IPrice';
import Translation from '../../../../../../common/components/translation/Translation';
import { GetSearchDealer_searchDealer } from '../../../../../../gqlCommon/graphql/queries/__generated__/GetSearchDealer';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import { StockVersionTypes } from '../../../../../../gqlCommon/enum/StockVersionTypes';
import useCheckTranslation from '../../../../../../gqlCommon/hooks/useCheckTranslation';
import { GetCustomizeCar_customizeCar_stockInfo } from '../../../../../graphql/queries/__generated__/GetCustomizeCar';
import { constants } from '../../../../../../../../common/constants/constants';
import useCustomerData from '../../../../../../gqlCommon/hooks/useCustomerData';

export interface IMultiCarPricesCash {
  primaryPrice: IPrice;
  loading?: boolean;
  onIndicativeClick: () => void;
  taxLabel?: string;
  stockInfo: GetCustomizeCar_customizeCar_stockInfo;
}

const SingleCurrencyCash: FC<IMultiCarPricesCash> = ({
  primaryPrice,
  loading,
  onIndicativeClick,
  taxLabel,
  stockInfo,
}) => {
  const styles = singleCurrencyCashStyles();
  const {
    platformConfig: { stockVersion },
  } = usePlatformConfig();
  const { customerData } = useCustomerData();
  const { label } = (customerData?.selectedDealer as GetSearchDealer_searchDealer) || {};
  const { translationHasValue } = useCheckTranslation();
  const dealerPriceLabelTranslation = 'trans__configurator__customise_page_sticky_footer__dealer_driveaway_price_label';

  return (
    <Box className={styles.price} display="flex" alignItems="center" data-test={'car_prices:cash:vehicle_total_price'}>
      <PriceWithLabel
        price={primaryPrice}
        loading={loading}
        taxLabel={taxLabel}
        isCache={true}
        label={
          <Box
            display="flex"
            data-test="customise:footer:vehicle_total_price"
            justifyContent="center"
            lineHeight="normal"
            textAlign="center"
          >
            <Typography className={styles.priceLabel} data-test="customise:footer:vehicle_total_price_label">
              {stockInfo &&
              stockInfo.stockType === constants.DEALER &&
              stockVersion !== StockVersionTypes.NONE &&
              translationHasValue(dealerPriceLabelTranslation) ? (
                <Translation id={dealerPriceLabelTranslation} values={{ dealerLabel: label }} />
              ) : (
                <Translation id="trans__configurator__customise_page_sticky_footer__driveaway_price_label" />
              )}
              <IndicativeNumber
                dataTest="vehicle_total_price"
                displayNumber={<Translation id="trans__configurator__indicative_numbers__vehicleTotalPrice" />}
                onClick={onIndicativeClick}
              />
            </Typography>
          </Box>
        }
      />
    </Box>
  );
};

export default SingleCurrencyCash;
